import * as Yup from 'yup';

import ContactsApi, { ContactMessageRequest } from '@/api/methods/contacts';
import AutoForm, {
    FieldGenerator, FormField, FormikProvider, useFormContext
} from '@/components/Formik';
import { Box } from '@mui/material';

const ContactForm = () => {

    // context
    const { setSubmitting, resetForm } = useFormContext();

    const fields: FormField[] = [
        FieldGenerator.text({
            name: 'email',
            label: 'Email',
            validation: Yup.string()
                .email('Enter a valid email')
                .required('Email is required'),
            props: { placeholder: 'Enter your email' },
        }),
        FieldGenerator.text({
            name: 'name',
            label: 'Name',
            validation: Yup.string()
                .min(2, 'Name should be at least 2 characters')
                .required('Name is required'),
            props: { placeholder: 'Enter your name' },
        }),
        FieldGenerator.text({
            name: 'message',
            label: 'Message',
            validation: Yup.string()
                .min(10, 'Message should be at least 10 characters')
                .required('Message is required'),
            props: { placeholder: 'Enter your message', multiline: true, rows: 4 },
        }),
    ];

    const handleSubmit = async (values: Record<string, any>) => {

        setSubmitting(true);

        const payload: ContactMessageRequest = {
            email: values.email,
            name: values.name,
            message: values.message,
        };
        await ContactsApi.sendMessage(payload).then((res) => {
            if (res.status === 201 || res.status === 200) {
                window.common.notify({
                    message: 'Message sent successfully!',
                    variant: 'success',
                });

                resetForm();
            } else {
                window.common.notify({
                    message: 'An error occurred while sending the message.',
                    variant: 'error',
                });
            }
        }).catch((error) => {
            console.error('Error:', error);
            window.common.notify({
                message: 'An error occurred while sending the message.',
                variant: 'error',
            });
        });

        setSubmitting(false);
    };

    return (
        <Box>
            <AutoForm
                config={{
                    size: 'medium',
                }}
                fields={fields}
                onSubmit={handleSubmit}
                submitButton={{ children: 'Send Message' }}
            />
        </Box>
    );
};

export default () => (
    <FormikProvider>
        <ContactForm />
    </FormikProvider>
);
